import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { autoRehydrate } from 'redux-persist';
import reducers from '../reducers';

const middleware = [thunk];

const store = createStore(
  reducers,
  {},
  composeWithDevTools(applyMiddleware(...middleware), autoRehydrate())
);

// persistStore(store, { storage: localStorage, whitelist: [''] });

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js